import React from 'react';
import { Grid, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';

import Button from 'components/Button';
import { uppercase } from 'utils/string';
import { sanlamDarkBlue } from 'Material-UI/colors';
import {
  StyledCaption,
  StyledGrid,
  StyledResGrid,
} from 'components/ItemInfoCard/styles';
import {
  StyledCard,
  StyledShortBody,
  StyledGridLeft,
} from 'containers/EpargnDashboard/Body/SituationEpargn/style';
import { styles } from 'components/ItemInfoCard/types';
import { pushTo } from 'helpers/routes';
import messages from 'components/ItemInfoCard/messages';
import { translate } from 'helpers/intl';
import { injectIntl } from 'react-intl';
import { SituationEpargnCardProps } from 'components/ItemInfoCard/types';
import PAGES from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { isReverse } from 'helpers/intl';
import { useSelector } from 'react-redux';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { EPARGN_PRODUCT_SCR_NAME } from 'constants/globalConstants';

const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    width: '98px !important',
    borderRadius: '6px',
    color: '#172C51 !important',
    border: '1px solid #E6E6E6 !important',
    '&:hover': {
      color: '#285BC7 !important',
    },
  },
});

const SituationEpargnCard = (props: SituationEpargnCardProps) => {
  const {
    product,
    dateValue,
    dateSituation,
    wrapperPaddingLeft,
    wrapperPaddingRight,
  } = props;
  const classes = useStyles();
  const styles: styles = {
    labelsColor: 'rgba(255,255,255,0.87)',
    valuesColor: '#566684',
    buttonRootStyles: classes.root,
  };
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <StyledCard
      paddingLeft={wrapperPaddingLeft}
      paddingRight={wrapperPaddingRight}
    >
      <StyledGrid
        container
        alignItems="center"
        justify="space-between"
        marginBottom={matches ? '17px' : '25px'}
      >
        <Grid item xs={5}>
          <Grid container alignItems="center">
            <Grid item>
              <StyledShortBody
                matches={matches}
                lineHeight={matches ? '0px' : '19px'}
                weight="bold"
                color={'#172C51'}
              >
                {uppercase(product || '')}
              </StyledShortBody>
            </Grid>
          </Grid>
        </Grid>
        <StyledGrid item xs={7}>
          <Grid container justify="flex-end">
            <Grid item>
              <StyledCaption
                matches={matches}
                color="#566684"
                marginBottom="0px"
                reverse={reverse}
                fontSize="11"
              >
                {uppercase(translate({ ...messages.SituationEpargn }, props))}
              </StyledCaption>
            </Grid>
            <StyledGridLeft item>
              <StyledCaption
                matches={matches}
                color="#566684"
                fontSize="11"
                marginBottom="0px"
              >
                {dateSituation}
              </StyledCaption>
            </StyledGridLeft>
          </Grid>
        </StyledGrid>
      </StyledGrid>
      <Grid container justify="space-between">
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <StyledCaption
              matches={matches}
              color="#9797AF"
              marginBottom="0px"
              fontSize="11"
            >
              {props.product === EPARGN_PRODUCT_SCR_NAME
                ? uppercase(translate({ ...messages.capitalGaranti }, props))
                : uppercase(translate({ ...messages.epargnConstitue }, props))}
            </StyledCaption>
          </Grid>
          <Grid item xs={6} dir="ltr">
            <StyledCaption
              matches={matches}
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              marginBottom="40px"
              textAlign={reverse ? 'left' : 'end'}
            >
              {dateValue}
            </StyledCaption>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6}>
            <Button
              variant="outlined"
              className={styles.buttonRootStyles}
              size="small"
              onClick={() => {
                props.setDetailsPageBreadcrumbsPath([
                  { name: 'epargn', route: PAGES.EPARGN_DASHBOARD },
                  { name: 'mesReleveDeSituation' },
                ]);
                pushTo(PAGES.EPARGN_DETAILS);
                GATracking.event(
                  EVENT_CATEGORIES.EPARGN_ACCUEIL,
                  EVENT_ACTION.CLICK,
                  'Ma situation à date_Voir détails',
                );
              }}
            >
              <StyledResGrid matches={matches}>
                {uppercase(translate({ ...messages.seeDetails }, props))}
              </StyledResGrid>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StyledCard>
  );
};

export default injectIntl(SituationEpargnCard);
